module.exports = __webpack_public_path__ + "img/nygl_logo.578e34ec.png";